import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

// Import the logo
import logo from "../imgs/logo.png";

// Import all the images
import img1051 from "../imgs/IMG_1051.PNG";
import img1052 from "../imgs/IMG_1052.PNG";
import img1053 from "../imgs/IMG_1053.PNG";
import img1054 from "../imgs/IMG_1054.PNG";
import img1055 from "../imgs/IMG_1055.PNG";
import img1056 from "../imgs/IMG_1056.PNG";
import img1057 from "../imgs/IMG_1057.PNG";
import img1058 from "../imgs/IMG_1058.PNG";
import img1059 from "../imgs/IMG_1059.PNG";
import img1060 from "../imgs/IMG_1060.PNG";
import img1061 from "../imgs/IMG_1061.PNG";

const Home = () => {
  // Array of all the images
  const images = [
    img1051,
    img1052,
    img1053,
    img1054,
    img1055,
    img1056,
    img1057,
    img1058,
    img1059,
    img1060,
    img1061,
  ];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Check if TikTok test mode is enabled
  const isTestMode = localStorage.getItem("tiktok-test-mode") === "true";

  // Function to handle App Store link click - handles TikTok in-app browser
  const handleAppStoreClick = (e) => {
    e.preventDefault();

    const appStoreUrl = "https://apps.apple.com/gb/app/viralz-app/id6745021669";
    const userAgent = navigator.userAgent || "";

    // Check if we're in an in-app browser (TikTok, Instagram, etc.)
    const isInAppBrowser =
      userAgent.includes("TikTok") ||
      userAgent.includes("musical_ly") ||
      userAgent.includes("Instagram") ||
      userAgent.includes("FBAN") ||
      userAgent.includes("FBAV");

    // Check if we're on iOS
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

    if (isInAppBrowser && isIOS) {
      // Use the iOS Shortcuts fallback technique to escape in-app browser
      try {
        const randomId = Math.random().toString(36).substring(2, 15);
        const shortcutsUrl = `shortcuts://x-callback-url/run-shortcut?name=${randomId}&x-error=${encodeURIComponent(
          appStoreUrl
        )}`;

        // Try the shortcuts escape method
        window.location.href = shortcutsUrl;

        // Fallback: Show instructions after a delay
        setTimeout(() => {
          alert(
            "If the App Store didn't open:\n\n1. Tap the '...' or 'Share' button\n2. Select 'Open in Safari'\n3. Then tap the download button again"
          );
        }, 2000);
      } catch (error) {
        // If shortcuts method fails, show instructions
        alert(
          "To download the app:\n\n1. Tap the '...' or 'Share' button\n2. Select 'Open in Safari'\n3. Then tap the download button again"
        );
      }
    } else if (isInAppBrowser) {
      // For Android in-app browsers, use intent links
      const intentUrl = `intent:${appStoreUrl}#Intent;end`;
      try {
        window.location.href = intentUrl;
      } catch (error) {
        window.location.href = appStoreUrl;
      }
    } else {
      // Normal browser - try multiple methods
      try {
        const newWindow = window.open(
          appStoreUrl,
          "_blank",
          "noopener,noreferrer"
        );
        setTimeout(() => {
          if (!newWindow || newWindow.closed) {
            window.location.href = appStoreUrl;
          }
        }, 100);
      } catch (error) {
        window.location.href = appStoreUrl;
      }
    }
  };

  // Auto-rotate images every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000);

    return () => clearInterval(interval);
  }, [images.length]);

  // Show Klaviyo form in all views
  useEffect(() => {
    const klaviyoForm = document.querySelector(".klaviyo-form-UnkHMP");

    if (klaviyoForm) {
      // Show the form in all views
      klaviyoForm.style.display = "block";

      const applyKlaviyoStyles = () => {
        if (klaviyoForm) {
          // Apply styles to the form container immediately
          klaviyoForm.style.width = "100%";
          klaviyoForm.style.maxWidth = "100%";
          klaviyoForm.style.display = "block";

          // Apply styles to all child elements immediately
          const allElements = klaviyoForm.querySelectorAll("*");
          allElements.forEach((element) => {
            element.style.width = "100%";
            element.style.maxWidth = "100%";
            element.style.boxSizing = "border-box";
          });
        }
      };

      // Apply styles immediately and continuously
      applyKlaviyoStyles();

      // Apply styles every 100ms for the first 10 seconds
      const interval = setInterval(() => {
        applyKlaviyoStyles();
      }, 100);

      // Keep applying styles for longer
      setTimeout(() => {
        clearInterval(interval);
      }, 10000);

      return () => {
        clearInterval(interval);
      };
    }
  }, []);

  return (
    <div className="home-wrapper">
      <div className="home-container">
        {/* Left Content */}
        <div className="left-content">
          {/* Logo and Brand - Stacked Vertically */}
          <div className="logo-brand-section">
            <div className="logo-container">
              <img src={logo} alt="ViralzApp Logo" className="logo-image" />
            </div>
            <div className="brand-text">
              <h1 className="brand-title">Viralz</h1>
              <p className="brand-subtitle">TikTok Analytics Platform</p>
            </div>
          </div>

          {/* Main Headline - Desktop Only */}
          <div className="main-headline-section desktop-only">
            <h2 className="main-headline">
              Analyze Your TikTok Performance Like a Pro
            </h2>
            <p className="main-subtitle">
              Get deep insights into your TikTok analytics, track performance
              metrics, and optimize your content strategy with our advanced
              analytics platform.
            </p>
          </div>

          {/* Download Buttons - Desktop Only */}
          <div className="download-buttons desktop-only">
            {/* App Store Button */}
            <a
              href="https://apps.apple.com/gb/app/viralz-app/id6745021669"
              className="download-btn app-store-btn"
              onClick={handleAppStoreClick}
            >
              <div className="shine-effect" />
              <svg
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="download-icon"
              >
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
              </svg>
              <div className="download-text">
                <span className="download-label">Download on the</span>
                <span className="download-store">App Store</span>
              </div>
            </a>

            {/* Google Play Button */}
            <button
              type="button"
              className="download-btn google-play-btn coming-soon-btn"
              disabled
            >
              <div className="shine-effect" />
              <svg
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="download-icon"
              >
                <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" />
              </svg>
              <div className="download-text">
                <span className="download-label">Coming Soon</span>
                <span className="download-store">Google Play</span>
              </div>
            </button>
          </div>
        </div>

        {/* NORMAL LAYOUT - When TikTok mode is OFF */}
        {!isTestMode && (
          <>
            {/* Mobile Download Buttons - Normal Mode */}
            <div className="download-buttons mobile-only">
              {/* App Store Button */}
              <a
                href="https://apps.apple.com/gb/app/viralz-app/id6745021669"
                className="download-btn app-store-btn"
                onClick={handleAppStoreClick}
              >
                <div className="shine-effect" />
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="download-icon"
                >
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                </svg>
                <div className="download-text">
                  <span className="download-label">Download on the</span>
                  <span className="download-store">App Store</span>
                </div>
              </a>

              {/* Google Play Button */}
              <button
                type="button"
                className="download-btn google-play-btn coming-soon-btn"
                disabled
              >
                <div className="shine-effect" />
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="download-icon"
                >
                  <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" />
                </svg>
                <div className="download-text">
                  <span className="download-label">Coming Soon</span>
                  <span className="download-store">Google Play</span>
                </div>
              </button>

              {/* Stats Section - Desktop Only */}
              <div className="stats-section desktop-only">
                <div className="stat-card">
                  <div className="shine-effect" />
                  <div className="stat-value">PRO</div>
                  <div className="stat-label">Analytics Tool</div>
                </div>

                <div className="stat-card">
                  <div className="shine-effect" />
                  <div className="stat-value">REAL</div>
                  <div className="stat-label">TikTok Data</div>
                </div>

                <div className="stat-card">
                  <div className="shine-effect" />
                  <div className="stat-value">FAST</div>
                  <div className="stat-label">AI Analysis</div>
                </div>
              </div>
            </div>

            {/* Right iPhone Mockup */}
            <div className="right-mockup">
              {/* Animated Glow Effect */}
              <div className="iphone-glow" />

              {/* iPhone Frame */}
              <div className="iphone-frame">
                {/* iPhone Notch */}
                <div className="iphone-notch" />

                {/* Screen */}
                <div className="iphone-screen">
                  {/* Image Carousel */}
                  <div className="image-carousel">
                    {images.map((image, index) => (
                      <div
                        key={index}
                        className={`carousel-slide ${
                          index === currentImageIndex ? "active" : ""
                        }`}
                      >
                        <img
                          src={image}
                          alt={`App Screenshot ${index + 1}`}
                          className="carousel-image"
                        />
                      </div>
                    ))}
                  </div>
                </div>

                {/* Side Buttons */}
                <div className="side-button volume-up" />
                <div className="side-button volume-down-1" />
                <div className="side-button volume-down-2" />
                <div className="side-button power-button" />
              </div>
            </div>

            {/* Main Headline - Mobile Only */}
            <div className="main-headline-section mobile-only">
              <h2 className="main-headline">
                Analyze Your TikTok Performance Like a Pro
              </h2>
              <p className="main-subtitle">
                Get deep insights into your TikTok analytics, track performance
                metrics, and optimize your content strategy with our advanced
                analytics platform.
              </p>
            </div>

            {/* Stats Section - Mobile Only */}
            <div className="stats-section mobile-only">
              <div className="stat-card">
                <div className="shine-effect" />
                <div className="stat-value">PRO</div>
                <div className="stat-label">Analytics Tool</div>
              </div>

              <div className="stat-card">
                <div className="shine-effect" />
                <div className="stat-value">REAL</div>
                <div className="stat-label">TikTok Data</div>
              </div>

              <div className="stat-card">
                <div className="shine-effect" />
                <div className="stat-value">FAST</div>
                <div className="stat-label">AI Analysis</div>
              </div>
            </div>
          </>
        )}

        {/* Klaviyo Form - Always visible */}
        <div className="klaviyo-form-UnkHMP"></div>

        {/* TIKTOK LAYOUT - When TikTok mode is ON */}
        {isTestMode && (
          <>
            {/* Phone Mockup - TikTok Mode (appears above buttons) */}
            <div className="right-mockup">
              {/* Animated Glow Effect */}
              <div className="iphone-glow" />

              {/* iPhone Frame */}
              <div className="iphone-frame">
                {/* iPhone Notch */}
                <div className="iphone-notch" />

                {/* Screen */}
                <div className="iphone-screen">
                  {/* Image Carousel */}
                  <div className="image-carousel">
                    {images.map((image, index) => (
                      <div
                        key={index}
                        className={`carousel-slide ${
                          index === currentImageIndex ? "active" : ""
                        }`}
                      >
                        <img
                          src={image}
                          alt={`App Screenshot ${index + 1}`}
                          className="carousel-image"
                        />
                      </div>
                    ))}
                  </div>
                </div>

                {/* Side Buttons */}
                <div className="side-button volume-up" />
                <div className="side-button volume-down-1" />
                <div className="side-button volume-down-2" />
                <div className="side-button power-button" />
              </div>
            </div>

            {/* Mobile Download Buttons - TikTok Mode */}
            <div className="download-buttons mobile-only">
              {/* App Store Button */}
              <a
                href="https://apps.apple.com/gb/app/viralz-app/id6745021669"
                className="download-btn app-store-btn"
                onClick={handleAppStoreClick}
              >
                <div className="shine-effect" />
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="download-icon"
                >
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                </svg>
                <div className="download-text">
                  <span className="download-label">Download on the</span>
                  <span className="download-store">App Store</span>
                </div>
              </a>

              {/* Google Play Button */}
              <button
                type="button"
                className="download-btn google-play-btn coming-soon-btn"
                disabled
              >
                <div className="shine-effect" />
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="download-icon"
                >
                  <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" />
                </svg>
                <div className="download-text">
                  <span className="download-label">Coming Soon</span>
                  <span className="download-store">Google Play</span>
                </div>
              </button>
            </div>
          </>
        )}
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          {/* Company Info */}
          <div className="footer-section">
            <div className="footer-brand">
              <div className="footer-logo-container">
                <img src={logo} alt="ViralzApp Logo" className="footer-logo" />
              </div>
              <h3 className="footer-brand-name">Viralz</h3>
            </div>
            <p className="footer-description">
              The ultimate TikTok analytics platform for creators and
              businesses. Get insights, track performance, and grow your
              audience.
            </p>
          </div>

          {/* Legal */}
          <div className="footer-section">
            <h4 className="footer-title">Legal</h4>
            <ul className="footer-links">
              <li>
                <Link to="/privacy-policy" className="footer-link">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-conditions" className="footer-link">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/cookie-policy" className="footer-link">
                  Cookie Policy
                </Link>
              </li>
              <li>
                <Link to="/gdpr-compliance" className="footer-link">
                  GDPR
                </Link>
              </li>
              <li>
                <Link to="/support" className="footer-link">
                  Support
                </Link>
              </li>
            </ul>
          </div>

          {/* Social & Connect */}
          <div className="footer-section">
            <h4 className="footer-title">Connect With Us</h4>
            <div className="social-links">
              <a
                href="https://www.tiktok.com/@viralz.app"
                className="social-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-.88-.05A6.33 6.33 0 0 0 5.12 20.9a6.34 6.34 0 0 0 10.86-4.43V7.93a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.16-.36z" />
                </svg>
              </a>
            </div>
            <p className="social-description">
              Follow us for the latest updates and TikTok analytics tips!
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        {/* <div className="footer-bottom">
          <p className="copyright">© 2024 ViralzApp. All rights reserved.</p>
          <div className="footer-bottom-links">
            <a href="#" className="footer-bottom-link">
              Status
            </a>
            <a href="#" className="footer-bottom-link">
              API
            </a>
            <a href="#" className="footer-bottom-link">
              Careers
            </a>
          </div>
        </div> */}
      </footer>

      {/* CSS Styles */}
      <style jsx>{`
        /* BASE STYLES */
        .home-wrapper {
          min-height: 100vh;
          background: #000000;
          color: #ffffff;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
            sans-serif;
          overflow: hidden;
        }

        .home-container {
          display: grid;
          grid-template-columns: 1fr 1fr;
          align-items: center;
          min-height: 100vh;
          max-width: 1400px;
          margin: 0 auto;
          padding: 0 60px;
          gap: 80px;
        }

        /* LEFT CONTENT */
        .left-content {
          display: flex;
          flex-direction: column;
          gap: 50px;
          max-width: 600px;
        }

        .logo-brand-section {
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 24px;
          text-align: left;
        }

        .logo-container {
          width: 80px;
          height: 80px;
          background: #000000;
          border-radius: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 0 20px #fe2c55, 0 0 40px rgba(254, 44, 85, 0.5),
            inset 0 0 0 2px #fe2c55;
          border: 1px solid #fe2c55;
        }

        .logo-image {
          width: 40px;
          height: 40px;
        }

        .brand-title {
          font-size: 2.8rem;
          font-weight: 800;
          margin: 0;
          margin-bottom: 8px;
          -webkit-background-clip: text;
          -webkit-text-fill-color: #fe2c55;
          background-clip: text;
        }

        .brand-subtitle {
          font-size: 1.2rem;
          color: #cccccc;
          margin: 0;
          font-weight: 500;
        }

        /* DOWNLOAD BUTTONS */
        .download-buttons {
          display: flex;
          gap: 20px;
          flex-wrap: wrap;
        }

        .download-btn {
          display: flex;
          align-items: center;
          gap: 16px;
          padding: 10px 12px;
          background: linear-gradient(135deg, #fe2c55, #ff6b9d);
          border-radius: 20px;
          text-decoration: none;
          color: white;
          font-weight: 700;
          font-size: 1.1rem;
          transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          border: 2px solid rgba(255, 255, 255, 0.1);
          cursor: pointer;
          box-shadow: 0 20px 60px rgba(254, 44, 85, 0.3),
            0 0 0 1px rgba(255, 255, 255, 0.1) inset;
          backdrop-filter: blur(10px);
          position: relative;
          overflow: hidden;
          min-width: 200px;
          justify-content: center;
        }

        .download-btn:hover {
          transform: translateY(-5px) scale(1.02);
          box-shadow: 0 30px 80px rgba(254, 44, 85, 0.5),
            0 0 0 2px rgba(255, 255, 255, 0.2) inset;
          background: linear-gradient(135deg, #ff6b9d, #fe2c55);
        }

        .download-icon {
          filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
        }

        .coming-soon-btn {
          opacity: 0.7;
          cursor: not-allowed;
          background: linear-gradient(135deg, #666666, #888888) !important;
        }

        .coming-soon-btn:hover {
          transform: none !important;
          box-shadow: 0 20px 60px rgba(102, 102, 102, 0.3),
            0 0 0 1px rgba(255, 255, 255, 0.1) inset !important;
          background: linear-gradient(135deg, #666666, #888888) !important;
        }

        .download-text {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }

        .download-label {
          font-size: 0.9rem;
          font-weight: 500;
          opacity: 0.9;
        }

        .download-store {
          font-size: 1.2rem;
          font-weight: 800;
          margin-top: -2px;
        }

        /* IPHONE MOCKUP */
        .right-mockup {
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .iphone-glow {
          position: absolute;
          width: 500px;
          height: 500px;
          border-radius: 50%;
          background: conic-gradient(from 0deg, #fe2c55, #ff6b9d, #fe2c55);
          animation: rotate 8s linear infinite;
          opacity: 0.4;
          filter: blur(30px);
        }

        .iphone-frame {
          position: relative;
          width: 320px;
          height: 640px;
          background: linear-gradient(145deg, #1a1a1a, #0a0a0a);
          border-radius: 50px;
          padding: 10px;
          box-shadow: 0 30px 80px rgba(0, 0, 0, 0.8), 0 0 0 2px #333333;
          z-index: 1;
          border: 3px solid #fe2c55;
        }

        .iphone-notch {
          position: absolute;
          top: 20px;
          left: 50%;
          transform: translateX(-50%);
          width: 100px;
          height: 25px;
          background: #000000;
          border-radius: 15px;
          z-index: 3;
          border: 2px solid #333333;
        }

        .iphone-screen {
          width: 100%;
          height: 100%;
          background: #000000;
          border-radius: 42px;
          overflow: hidden;
          position: relative;
          border: 2px solid #333333;
        }

        .image-carousel {
          position: relative;
          width: 100%;
          height: 100%;
          overflow: hidden;
        }

        .carousel-slide {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          opacity: 0;
          transform: translateX(100%);
          transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .carousel-slide.active {
          opacity: 1;
          transform: translateX(0%);
        }

        .carousel-image {
          width: 100%;
          height: 100%;
          object-fit: contain;
          border-radius: 40px;
        }

        .side-button {
          position: absolute;
          background: #fe2c55;
          border-radius: 3px 0 0 3px;
        }

        .volume-up {
          left: -6px;
          top: 120px;
          width: 6px;
          height: 60px;
        }

        .volume-down-1 {
          left: -6px;
          top: 200px;
          width: 6px;
          height: 40px;
        }

        .volume-down-2 {
          left: -6px;
          top: 260px;
          width: 6px;
          height: 40px;
        }

        .power-button {
          right: -6px;
          top: 150px;
          width: 6px;
          height: 80px;
        }

        /* MAIN HEADLINE */
        .main-headline-section {
          text-align: left;
          max-width: 100%;
          margin: 0;
          padding: 0;
          display: flex;
          flex-direction: column;
          gap: 24px;
        }

        .main-headline {
          font-size: 3.5rem;
          font-weight: 900;
          line-height: 1.1;
          margin: 0;
          background: linear-gradient(135deg, #ffffff, #cccccc);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .main-subtitle {
          font-size: 1.25rem;
          color: #cccccc;
          line-height: 1.7;
          margin: 0;
          font-weight: 500;
          max-width: 520px;
        }

        /* STATS SECTION */
        .stats-section {
          display: flex;
          gap: 24px;
          justify-content: flex-start;
          align-items: center;
          flex-wrap: wrap;
          width: 100%;
          max-width: 100%;
          margin: 0;
          padding: 0;
        }

        .stat-card {
          position: relative;
          padding: 20px 24px;
          background: linear-gradient(
            135deg,
            rgba(254, 44, 85, 0.1),
            rgba(255, 107, 157, 0.05)
          );
          border-radius: 18px;
          border: 2px solid rgba(254, 44, 85, 0.2);
          backdrop-filter: blur(20px);
          text-align: center;
          min-width: 120px;
          flex: 0 0 auto;
          max-width: 160px;
          transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          cursor: pointer;
          overflow: hidden;
        }

        .stat-card:hover {
          transform: translateY(-8px) scale(1.05);
          box-shadow: 0 25px 50px rgba(254, 44, 85, 0.3);
          border: 2px solid rgba(254, 44, 85, 0.4);
        }

        .stat-value {
          font-size: 2.8rem;
          font-weight: 900;
          background: linear-gradient(135deg, #fe2c55, #ff6b9d);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          margin-bottom: 8px;
          filter: drop-shadow(0 2px 4px rgba(254, 44, 85, 0.3));
        }

        .stat-label {
          font-size: 0.95rem;
          color: #ffffff;
          font-weight: 600;
          opacity: 0.9;
        }

        /* FOOTER */
        .footer {
          margin-top: 80px;
          padding: 60px 60px 40px;
          border-top: 1px solid rgba(255, 255, 255, 0.1);
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0.5) 0%,
            rgba(0, 0, 0, 0.8) 100%
          );
          backdrop-filter: blur(20px);
        }

        .footer-content {
          max-width: 1400px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 50px;
        }

        .footer-brand {
          display: flex;
          align-items: center;
          gap: 15px;
          margin-bottom: 25px;
        }

        .footer-logo-container {
          width: 50px;
          height: 50px;
          background: #000000;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 0 15px #fe2c55, 0 0 30px rgba(254, 44, 85, 0.3),
            inset 0 0 0 1px #fe2c55;
          border: 1px solid #fe2c55;
        }

        .footer-logo {
          width: 24px;
          height: 24px;
        }

        .footer-brand-name {
          font-size: 1.8rem;
          font-weight: 800;
          margin: 0;
          -webkit-text-fill-color: #fe2c55;
        }

        .footer-description {
          color: #cccccc;
          font-size: 1rem;
          line-height: 1.6;
          margin: 0;
          max-width: 280px;
        }

        .footer-title {
          color: #ffffff;
          font-size: 1.2rem;
          font-weight: 700;
          margin-bottom: 20px;
        }

        .footer-links {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .footer-link {
          color: #cccccc;
          text-decoration: none;
          font-size: 1rem;
          transition: all 0.3s ease;
          display: block;
          padding: 4px 0;
        }

        .footer-link:hover {
          color: #fe2c55;
          transform: translateX(5px);
        }

        .social-links {
          display: flex;
          gap: 15px;
          margin-bottom: 25px;
        }

        .social-link {
          width: 45px;
          height: 45px;
          border-radius: 12px;
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.1);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.2rem;
          text-decoration: none;
          transition: all 0.3s ease;
          backdrop-filter: blur(10px);
        }

        .social-link:hover {
          transform: translateY(-3px) scale(1.1);
          background: rgba(254, 44, 85, 0.2);
          border-color: #fe2c55;
          box-shadow: 0 10px 30px rgba(254, 44, 85, 0.3);
        }

        .social-description {
          color: #cccccc;
          font-size: 0.9rem;
          margin: 0;
          line-height: 1.5;
        }

        .footer-bottom {
          margin-top: 50px;
          padding-top: 30px;
          border-top: 1px solid rgba(255, 255, 255, 0.1);
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 20px;
        }

        .copyright {
          color: #888888;
          font-size: 0.9rem;
          margin: 0;
        }

        .footer-bottom-links {
          display: flex;
          gap: 25px;
          align-items: center;
        }

        .footer-bottom-link {
          color: #888888;
          text-decoration: none;
          font-size: 0.9rem;
          transition: color 0.3s ease;
        }

        .footer-bottom-link:hover {
          color: #fe2c55;
        }

        /* ANIMATIONS */
        @keyframes rotate {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }

        .shine-effect {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            45deg,
            transparent 30%,
            rgba(255, 255, 255, 0.1) 50%,
            transparent 70%
          );
          transform: translateX(-100%);
          transition: transform 0.6s ease;
        }

        .shine-effect:hover {
          transform: translateX(100%) !important;
        }

        /* VISIBILITY CONTROLS */
        .desktop-only {
          display: flex;
        }

        .mobile-only {
          display: none;
        }

        /* DESKTOP STYLES - Ensure proper desktop layout */
        @media (min-width: 1101px) {
          .mobile-only {
            display: none !important;
          }

          .desktop-only {
            display: flex !important;
          }

          .home-container {
            display: grid !important;
            grid-template-columns: 1fr 1fr !important;
            align-items: center !important;
            min-height: 100vh !important;
            max-width: 1400px !important;
            margin: 0 auto !important;
            padding: 0 60px !important;
            gap: 80px !important;
          }

          .left-content {
            display: flex !important;
            flex-direction: column !important;
            gap: 40px !important;
            max-width: 600px !important;
            order: unset !important;
            align-items: unset !important;
          }

          .right-mockup {
            order: unset !important;
            margin: unset !important;
          }

          .main-headline-section {
            order: unset !important;
            margin: 20px auto 0 !important;
          }

          .stats-section {
            order: unset !important;
            flex-direction: row !important;
            gap: 30px !important;
            align-items: center !important;
            margin: 60px auto 0 !important;
            padding: 0 60px !important;
          }
        }

        /* MOBILE STYLES */
        @media (max-width: 1100px) {
          .home-container {
            display: flex !important;
            flex-direction: column !important;
            grid-template-columns: none !important;
            gap: 40px !important;
            padding: 20px !important;
            text-align: center !important;
          }

          .left-content {
            max-width: 100% !important;
            align-items: center !important;
          }

          /* Mobile Logo Layout - Column */
          .logo-brand-section {
            flex-direction: column !important;
            text-align: center !important;
            gap: 16px !important;
          }

          /* Mobile Logo Sizing */
          .logo-container {
            width: 60px !important;
            height: 60px !important;
          }

          .logo-image {
            width: 30px !important;
            height: 30px !important;
          }

          .brand-title {
            font-size: 2.2rem !important;
          }

          .brand-subtitle {
            font-size: 1rem !important;
          }

          .desktop-only {
            display: none !important;
          }

          .mobile-only {
            display: flex !important;
            flex-direction: column !important;
            align-items: center !important;
            gap: 15px !important;
            margin-top: 20px !important;
          }

          .mobile-only .download-btn {
            width: 100% !important;
            max-width: 280px !important;
            padding: 16px 24px !important;
            font-size: 1rem !important;
          }

          .mobile-only .download-icon {
            width: 24px !important;
            height: 24px !important;
          }

          .mobile-only .download-label {
            font-size: 0.8rem !important;
          }

          .mobile-only .download-store {
            font-size: 1.1rem !important;
          }

          .right-mockup {
            margin: 20px 0 !important;
          }

          .main-headline-section {
            order: 4 !important;
            padding: 0 20px !important;
            margin: 20px auto 0 !important;
            text-align: center !important;
          }

          .stats-section {
            order: 5 !important;
            flex-direction: column !important;
            gap: 20px !important;
            align-items: center !important;
            margin: 40px auto 0 !important;
            padding: 0 20px !important;
          }

          .stat-card {
            max-width: 280px !important;
            min-width: 250px !important;
          }

          .main-headline {
            font-size: 2rem !important;
          }

          /* iPhone mockup sizing for mobile */
          .iphone-glow {
            width: 350px !important;
            height: 350px !important;
          }

          .iphone-frame {
            width: 250px !important;
            height: 500px !important;
          }
        }

        @media (max-width: 480px) {
          .home-container {
            margin-top: 20px !important;
            padding: 15px !important;
            gap: 0px !important;
          }

          /* Mobile Logo Layout - Column */
          .logo-brand-section {
            flex-direction: column !important;
            text-align: center !important;
            gap: 12px !important;
          }

          /* Smaller logo for small screens */
          .logo-container {
            width: 50px !important;
            height: 50px !important;
          }

          .logo-image {
            width: 25px !important;
            height: 25px !important;
          }

          .brand-title {
            font-size: 1.8rem !important;
          }

          .brand-subtitle {
            font-size: 0.9rem !important;
          }

          .main-headline {
            font-size: 1.8rem !important;
          }

          .main-headline-section {
            padding: 0 15px !important;
            text-align: center !important;
          }

          .stats-section {
            padding: 0 15px !important;
          }

          .stat-card {
            max-width: 260px !important;
            min-width: 240px !important;
            padding: 20px !important;
          }

          .mobile-only .download-btn {
            padding: 7px 20px !important;
            font-size: 0.9rem !important;
            max-width: 260px !important;
          }

          .mobile-only .download-icon {
            width: 22px !important;
            height: 22px !important;
          }

          .mobile-only .download-label {
            font-size: 0.75rem !important;
          }

          .mobile-only .download-store {
            font-size: 1rem !important;
          }

          /* Smaller iPhone mockup for small screens */
          .iphone-glow {
            width: 300px !important;
            height: 300px !important;
          }

          .iphone-frame {
            width: 220px !important;
            height: 440px !important;
          }
        }

        @media (max-width: 360px) {
          .home-container {
            padding: 10px !important;
            gap: 0px !important;
          }

          /* Mobile Logo Layout - Column */
          .logo-brand-section {
            flex-direction: column !important;
            text-align: center !important;
            gap: 10px !important;
          }

          /* Extra small logo */
          .logo-container {
            width: 45px !important;
            height: 45px !important;
          }

          .logo-image {
            width: 22px !important;
            height: 22px !important;
          }

          .brand-title {
            font-size: 1.6rem !important;
          }

          .brand-subtitle {
            font-size: 0.85rem !important;
          }

          .main-headline {
            font-size: 1.6rem !important;
          }

          .main-headline-section {
            padding: 0 10px !important;
            text-align: center !important;
          }

          .stats-section {
            padding: 0 10px !important;
          }

          .stat-card {
            max-width: 240px !important;
            min-width: 220px !important;
          }

          .mobile-only .download-btn {
            padding: 12px 18px !important;
            font-size: 0.85rem !important;
            max-width: 240px !important;
          }

          .mobile-only .download-icon {
            width: 20px !important;
            height: 20px !important;
          }

          .mobile-only .download-label {
            font-size: 0.7rem !important;
          }

          .mobile-only .download-store {
            font-size: 0.95rem !important;
          }

          /* Extra small iPhone mockup */
          .iphone-glow {
            width: 250px !important;
            height: 250px !important;
          }

          .iphone-frame {
            width: 200px !important;
            height: 400px !important;
          }
        }
      `}</style>
    </div>
  );
};

export default Home;
